<div
  class="rounded-md transition-all"
  [class]="
    compressed()
      ? ''
      : variant() === 'STOM'
        ? 'border-4 border-dashed border-rose-500 bg-rose-500/50 p-4'
        : 'border-4 border-dashed border-emerald-500 bg-emerald-500/50 p-4'
  "
>
  <ng-content></ng-content>
</div>
